<template>
    <DsModal
        :is-open="isOpen"
        show-close
        :title="$t('funnel.edit.lightbox.restore')"
        size="sm"
        class="restore-version-modal"
        @close="closeRestoreVersion"
    >
        <template #header>
            <DsFilledButton
                data-qa="restore-button"
                :disabled="disableRestore"
                @click="restoreRevision"
            >
                {{ $t('funnel.edit.restore') }}
            </DsFilledButton>
        </template>

        <template #default>
            <DsInlineAlert leading-icon type="warning">
                {{ $t('funnel.edit.restore.warning') }}
            </DsInlineAlert>

            <DsListItem
                v-for="(restoreVersion, i) in restoreVersions"
                :key="i"
                class="list-version-item"
                :data-qa="`date_${restoreVersion.date}`"
                :title="restoreVersion.date"
                :short-description="`Saved by ${restoreVersion.user}`"
            >
                <template #leading>
                    <DsIcon name="save" />
                </template>

                <template #trailing>
                    <DsRadio
                        v-model="versionIdSelected"
                        :val="restoreVersion.id"
                        :data-qa="`id_${restoreVersion.id}`"
                        @input="updateVersion(restoreVersion.id)"
                    />
                </template>
            </DsListItem>
        </template>
    </DsModal>
</template>

<script>
import { loadRestoredVersions } from './restore.version.api';

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
    },
    emits: ['restore-version', 'close-restore-version'],
    data() {
        return {
            restoreVersions: [],
            disableRestore: true,
            versionIdSelected: '',
        };
    },

    mounted() {
        this.loadRestoredVersions();
    },

    methods: {
        async loadRestoredVersions() {
            try {
                const data = await loadRestoredVersions(this.funnelId);
                const { revisions } = data;

                Object.entries(revisions).forEach((entry) => {
                    const [id, version] = entry;
                    const [date, user] = version.split('-');

                    this.restoreVersions.push({ id, user, date });
                });
            } catch (error) {
                this.$error({ message: this.$t('funnel.edit.restore.loading.error') });
            }
        },

        async restoreRevision() {
            try {
                const event = {
                    revisionId: this.versionIdSelected,
                };

                this.$emit('restore-version', event);
            } catch (error) {
                this.$error({ message: this.$t('funnel.edit.restore.failure') });
            }
        },

        updateVersion(id) {
            this.versionIdSelected = id;
            this.disableRestore = false;
        },

        closeRestoreVersion() {
            this.$emit('close-restore-version');
        },
    },
};
</script>

<style lang="scss">

.restore-version-modal {
    div.modal-body {
        padding: 0;
    }

    div.label-container {
        display: none;
    }

    div.list-version-item div.list-item-info {
        padding-bottom: 0px;
        padding-right: 0px;
    }
}

</style>
